"use strict";
/**
 * CatalogItem Request Types
 *
 * Request DTOs for catalog item endpoints.
 */
Object.defineProperty(exports, "__esModule", { value: true });
